import { render, staticRenderFns } from "./SectionProgramGeneral.vue?vue&type=template&id=8301ee68&scoped=true&"
import script from "./SectionProgramGeneral.vue?vue&type=script&lang=js&"
export * from "./SectionProgramGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SectionProgramGeneral.vue?vue&type=style&index=0&id=8301ee68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8301ee68",
  null
  
)

export default component.exports